namespace TabAurous.Inventory {
    export interface SetItemsRow {
        ItemId?: number;
        SetId?: number;
        StockId?: number;
        ProductId?: number;
        Line_No?: number;
        SKU?: string;
        AttributeId?: number;
        ProductCode?: string;
    }

    export namespace SetItemsRow {
        export const idProperty = 'ItemId';
        export const nameProperty = 'SKU';
        export const localTextPrefix = 'Inventory.SetItems';
        export const deletePermission = 'Inventory:Set:Delete';
        export const insertPermission = 'Inventory:Set:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:Set:Edit';

        export declare const enum Fields {
            ItemId = "ItemId",
            SetId = "SetId",
            StockId = "StockId",
            ProductId = "ProductId",
            Line_No = "Line_No",
            SKU = "SKU",
            AttributeId = "AttributeId",
            ProductCode = "ProductCode"
        }
    }
}
